module.exports = __webpack_public_path__ + "img/ring_g_e_1_0@3x.d97de070.png";